// GOBLIN GEAR — Armory Loadout. Drives sections/gg-armory-loadout.liquid.
// Behaviour is a 1:1 port of HTML/Armory Loadout.dc.html (Claude Design):
//   · two slots, Elbow first then Wrist; Elbow opens armed with the flagship, Wrist unarmed
//   · the stage shows the active slot's equipped tier (or the flagship shot while unarmed)
//   · summary + total list armed slots only; the button adds real variants via /cart/add.js,
//     or reads "Coming soon" while no variant is purchasable (products still drafts).
// Oct 4 2026: sold-out tiers are greyed out and can't be equipped, per slot. Stock is automatic from
//   Shopify: each tier button carries data-wrist-available / data-elbow-available (printed by the
//   section from product.available), with the cart drawer's Wave 1 list (#ggCartConfig) as a fallback.
//   If the default tier is sold out for a slot, the next in-stock tier is armed instead.
//   SKUs are back-office only, so the tier picker no longer prints one.
(function () {
  function parseMoney(s) { var n = parseFloat(String(s || '').replace(/[^0-9.]/g, '')); return isNaN(n) ? 0 : n; }
  function fmt(n) { var f = window.GG_MONEY_FORMAT || '${{amount}}'; return f.replace(/\{\{\s*amount[^}]*\}\}/, n.toFixed(2)); }
  function txt(el, v) { if (el) el.textContent = v == null ? '' : v; }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // variant id -> in stock? (true / false). Variants not in the list count as in stock.
  function stockMap() {
    var map = {};
    try {
      var el = document.getElementById('ggCartConfig');
      var cfg = el ? JSON.parse(el.textContent) : null;
      ((cfg && cfg.wave1) || []).forEach(function (p) { if (p && p.id) map[String(p.id)] = p.available !== false; });
    } catch (e) {}
    return map;
  }

  function init(root) {
    if (root.__ggx) return; root.__ggx = true;
    var tiers = Array.prototype.slice.call(root.querySelectorAll('.ggx-tier'));
    if (!tiers.length) return;
    var q = function (s) { return root.querySelector(s); };
    var qa = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };
    var slots = qa('.ggx-slot');
    var order = slots.map(function (b) { return b.dataset.slot; });            // ['elbow','wrist']
    var names = {}; slots.forEach(function (b) { names[b.dataset.slot] = b.dataset.slotName; });
    var codes = {}; slots.forEach(function (b) { codes[b.dataset.slot] = b.dataset.slotCode; });
    var stock = stockMap();
    function inStock(i, slot) {
      if (i == null || !tiers[i]) return false;
      var av = tiers[i].dataset[slot + 'Available'];
      if (av === 'false') return false;                                         // Shopify says sold out
      if (av === 'true') return true;
      var id = tiers[i].dataset[slot + 'Variant'];
      if (!id) return true;                                                     // pre-launch tier: "Coming soon", still selectable
      return stock[String(id)] !== false;
    }
    function firstInStock(slot, from) {
      if (inStock(from, slot)) return from;
      for (var i = 0; i < tiers.length; i++) { if (inStock(i, slot)) return i; }
      return null;
    }
    var flagship = Number(root.dataset.defaultTier || 0);
    var first = root.dataset.defaultSlot || order[0];
    var state = { active: first, equipped: {}, compare: true, added: false, error: '' };
    order.forEach(function (s) { state.equipped[s] = null; });
    state.equipped[first] = firstInStock(first, flagship);

    function t(i) { return i == null ? null : tiers[i].dataset; }
    function price(td, slot) { return td ? (td[slot + 'Price'] || '') : ''; }
    function refire(el) { if (!el) return; el.classList.remove('gl-fire'); void el.offsetWidth; el.classList.add('gl-fire'); setTimeout(function () { el.classList.remove('gl-fire'); }, 600); }

    var lastKey = null;
    function render() {
      var a = state.active, ai = state.equipped[a], td = t(ai), shotTd = td || t(flagship);

      // stage
      var shot = shotTd ? shotTd[a + 'Shot'] : '';
      var shotEl = q('[data-stage-shot]');
      if (shotEl) { shotEl.style.backgroundImage = shot ? 'url("' + shot + '")' : 'none'; shotEl.setAttribute('aria-label', (td ? td.name : '') + ' ' + names[a]); }
      txt(q('[data-stage-code]'), 'GG · ' + codes[a] + ' · ' + (td ? td.code : '--'));
      txt(q('[data-stage-slot]'), names[a]);
      txt(q('[data-stage-tier]'), td ? td.name : 'Select a tier');
      txt(q('[data-stage-cat]'), names[a]);
      txt(q('[data-stage-line]'), td ? td.line : 'Pick a tier below to arm this slot.');
      var key = a + '-' + ai; if (lastKey !== null && key !== lastKey) refire(q('[data-stage-tier]')); lastKey = key;

      // slots
      var armed = order.filter(function (s) { return state.equipped[s] != null; });
      txt(q('[data-slots-label]'), 'Slots · ' + armed.length + ' of ' + order.length + ' armed');
      slots.forEach(function (b) {
        var s = b.dataset.slot, st = t(state.equipped[s]), on = s === a;
        b.classList.toggle('is-on', on); b.classList.toggle('is-armed', !!st);
        txt(b.querySelector('[data-slot-tier]'), st ? st.name : 'Not armed');
        txt(b.querySelector('[data-slot-price]'), st ? price(st, s) : '');
        txt(b.querySelector('[data-slot-state]'), st ? 'Armed' : (on ? 'Select a tier below' : 'Select this slot'));
        var mk = b.querySelector('[data-slot-mark]');
        if (mk) { if (st && st.mark) mk.style.backgroundImage = 'url("' + st.mark + '")'; else mk.removeAttribute('style'); }
      });

      // tier picker (sold-out tiers for this slot are greyed out and can't be equipped)
      txt(q('[data-active-slot]'), names[a]);
      txt(q('[data-active-sku]'), '');
      tiers.forEach(function (b, i) {
        var out = !inStock(i, a);
        b.classList.toggle('is-on', i === ai);
        b.classList.toggle('is-out', out);
        b.disabled = out;
        b.setAttribute('aria-disabled', out ? 'true' : 'false');
        b.title = out ? (b.dataset.name || '') + ' ' + names[a] + ' — sold out' : '';
        txt(b.querySelector('[data-tier-price]'), out ? 'Sold out' : (b.dataset[a + 'Price'] || ''));
      });

      // readout
      qa('[data-compare-h]').forEach(function (h) { h.classList.toggle('is-on', Number(h.dataset.compareH) === ai); });
      ['support', 'strength', 'stiffness'].forEach(function (k) {
        var n = td ? Number(td[k]) || 0 : 0;
        qa('[data-single="' + k + '"] > span').forEach(function (seg, j) { seg.classList.toggle('on', j < n); });
      });
      var single = q('[data-readout-single]'), cmp = q('[data-readout-compare]');
      if (single) single.hidden = state.compare;
      if (cmp) cmp.hidden = !state.compare;
      txt(q('[data-compare]'), state.compare ? 'Single readout' : 'Compare all tiers');

      // summary
      var total = 0, tba = false, html = '';
      armed.forEach(function (s) { var st = t(state.equipped[s]), p = price(st, s); if (!/[0-9]/.test(p)) tba = true; total += parseMoney(p); html += '<div class="ggx-line"><span>' + esc(names[s]) + ' — ' + esc(st.name) + '</span><b>' + esc(p) + '</b></div>'; });
      var lines = q('[data-sum-lines]'); if (lines) lines.innerHTML = html;
      txt(q('[data-sum-total]'), tba ? 'TBA' : fmt(total));
      txt(q('[data-sum-note]'), state.error || (armed.length === order.length ? 'Both slots add to the cart. Bundle & Save applies at checkout.' : 'One slot at a time. Arm the other slot to build the full loadout.'));

      // button
      var btn = q('[data-add-loadout]'), lbl = q('[data-cta-label]');
      var live = armed.some(function (s) { return t(state.equipped[s])[s + 'Variant'] && inStock(state.equipped[s], s); });
      if (btn) {
        btn.classList.toggle('is-presale', !live);
        btn.setAttribute('aria-disabled', live && armed.length ? 'false' : 'true');
        txt(lbl, state.added ? 'Loadout equipped' : !armed.length ? 'Arm a slot to continue' : live ? btn.dataset.liveLabel : btn.dataset.soonLabel);
      }
    }

    slots.forEach(function (b) { b.addEventListener('click', function () { state.active = b.dataset.slot; state.added = false; state.error = ''; render(); }); });
    tiers.forEach(function (b, i) { b.addEventListener('click', function () { if (!inStock(i, state.active)) return; state.equipped[state.active] = i; state.added = false; state.error = ''; render(); }); });
    var cmpBtn = q('[data-compare]'); if (cmpBtn) cmpBtn.addEventListener('click', function () { state.compare = !state.compare; render(); });
    var add = q('[data-add-loadout]');
    if (add) add.addEventListener('click', function () {
      var items = order.map(function (s) { var i = state.equipped[s], st = t(i); var id = st && st[s + 'Variant']; return id && inStock(i, s) ? { id: Number(id), quantity: 1 } : null; }).filter(Boolean);
      if (!items.length) return;
      add.disabled = true;
      fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          add.disabled = false;
          if (!res.ok) { state.added = false; state.error = (res.j && (res.j.description || res.j.message)) || 'Part of this loadout is not available right now.'; render(); return; }
          state.added = true; state.error = ''; render(); document.dispatchEvent(new CustomEvent('gg:cart:refresh')); if (window.GGCart && GGCart.refresh) GGCart.refresh();
        })
        .catch(function () { add.disabled = false; });
    });
    render();
  }

  function boot() { document.querySelectorAll('[data-armory]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) { e.target.querySelectorAll('[data-armory]').forEach(function (r) { r.__ggx = false; init(r); }); });
})();
